import { ScheduleOutlined } from '@mui/icons-material';
import { Avatar, Chip, Divider, Stack, Typography } from '@mui/material';
import { InformationPage, PageSections, SectionCard, ValueBadge, designTokens } from '../../../design-system';
import type { SecurityAuditViewer } from '../audit/model';

export type SecurityAuditPageProps = {
  viewer: SecurityAuditViewer;
};

export function SecurityAuditPage({ viewer }: SecurityAuditPageProps) {
  const rows: ReadonlyArray<readonly [label: string, value: string]> = [
    ['테넌트', viewer.tenant],
    ['인증 주체', viewer.principalType === 'human' ? '사용자' : '서비스 계정'],
    ['역할', `${viewer.roleCount}개`],
    ['권한 범위', `${viewer.scopeCount}개`],
  ];

  return (
    <InformationPage title="내 접근 정보" help="권한 변경이 필요하면 회사 관리자에게 문의해 주세요." width="compact">
      <PageSections>
        <SectionCard title="현재 접근 상태" headerPadding="compact">
          <Stack divider={<Divider />}>
            {rows.map(([label, value]) => (
              <Stack
                key={label}
                direction="row"
                spacing={1.25}
                sx={{ px: `${designTokens.layout.sectionCardBodyPadding}px`, py: 1.3, alignItems: 'center' }}
              >
                <Avatar
                  variant="rounded"
                  sx={{ width: 30, height: 30, bgcolor: 'action.hover', color: 'text.secondary' }}
                >
                  <ScheduleOutlined />
                </Avatar>
                <Typography variant="body2" sx={{ flex: 1, fontWeight: 700 }}>{label}</Typography>
                {label === '인증 주체' ? <ValueBadge label={value} /> : <Chip variant="outlined" label={value} />}
              </Stack>
            ))}
          </Stack>
        </SectionCard>
      </PageSections>
    </InformationPage>
  );
}
